import { Ref, ref, watch } from 'vue'

import {
  MultiSelectObjectOption,
  MultiSelectOptionValue,
} from '@collector/shared-ui'
import { isLettersAndSpaces } from '@collector/shared-utils'

export function useSearchTermOptions(
  fetchSelectOptions: (
    searchTermValue?: string,
  ) => Promise<MultiSelectObjectOption[]>,
): {
  defaultOptions: Promise<MultiSelectObjectOption[]>
  selectedValue: Ref<MultiSelectOptionValue | undefined>
  searchTerm: Ref<string>
  selectedValueOptions: Ref<MultiSelectObjectOption[] | undefined>
  options: Ref<Promise<MultiSelectObjectOption[]> | MultiSelectObjectOption[]>
} {
  const defaultOptions = fetchSelectOptions()

  // state
  const selectedValue = ref<MultiSelectOptionValue>()
  const selectedValueOptions = ref<MultiSelectObjectOption[]>()
  const searchTerm = ref('')
  const options: Ref<
    Promise<MultiSelectObjectOption[]> | MultiSelectObjectOption[]
  > = ref(defaultOptions)

  // methods
  async function fetchAvailableOptions(
    searchTermValue: string,
  ): Promise<MultiSelectObjectOption[]> {
    const options = await fetchSelectOptions(searchTermValue)

    if (options.length) {
      return options
    }

    return defaultOptions
  }

  async function getSearchTermOptions(searchTermValue: string): Promise<void> {
    if (isLettersAndSpaces(searchTermValue) && searchTermValue.length > 2) {
      options.value = fetchAvailableOptions(searchTermValue)
    } else if (selectedValueOptions.value) {
      // if search term is not valid, use selected value options
      options.value = selectedValueOptions.value
    } else if (selectedValue.value === undefined) {
      // if value is cleared
      options.value = defaultOptions
    }
  }

  // init
  watch(searchTerm, () => {
    getSearchTermOptions(searchTerm.value.trim())
  })

  return {
    defaultOptions,
    selectedValue,
    selectedValueOptions,
    searchTerm,
    options,
  }
}
